import React, { useEffect, useState } from 'react'
import { Select, SelectChangeEvent, MenuItem, FormControl, OutlinedInput, Box} from '@mui/material'
import { Regions } from 'src/constant/Region';
import { RegionsType } from 'src/types/SchoolType';
import ManageRegionMyinfo from './ManageRegionMyinfo';

interface Props{
    user_area?: RegionsType
    setRegion:React.Dispatch<React.SetStateAction<RegionsType>>
}

const RegionSelectorMyInfo = ({user_area,setRegion}:Props) => {
    const contents = Regions
    const menuProps = {
        PaperProps: {
            sx: {
              maxHeight: '200px',
              overflowY: 'auto',
            },
          },
          TransitionProps: {
            onEntering: (menuElement: HTMLElement) => {
              menuElement.scrollTop = 0;
            },
          },
    }
    const sx = {
            height:46
    }
    const [wideloc,setWideLoc] = useState('')
    const [cityloc,setCityLoc] = useState('')
    const [locations,setLocations] = useState<RegionsType>(user_area ?? {})


    const handleKeyChange = (e:SelectChangeEvent<string>)=>{
        setWideLoc(e.target.value)
        if(wideloc){
            setCityLoc('')
        }
    }
    const handleValueChange = (e: SelectChangeEvent<string>) => {
        const newCity_loc = e.target.value;
        setCityLoc(newCity_loc);
      
        let wideKey = wideloc; // 예: "서울특별시" → "서울"
        if (wideloc.endsWith('남도') || wideloc.endsWith('북도')) {
          wideKey =  wideloc[0] + wideloc[2]; // 예: 전라남도 → 전남 (0:'전', 2:'남')
        }
        else{
          wideKey = wideloc.slice(0, 2); // 예: 서울특별시 → 서울
        }
      
        // 현재 상태 복사
        const newLocations = { ...locations };
      
        if (newCity_loc === "전체") {
          newLocations[wideKey] = ["전체"];
        } else {
          const existing = newLocations[wideKey] ?? [];
      
          const updated = existing.filter((item) => item !== "전체");
      
          if (!updated.includes(newCity_loc)) {
            newLocations[wideKey] = [...updated, newCity_loc];
          } else {
            newLocations[wideKey] = updated;
          }
        }
      
        setLocations(newLocations);
      };
      useEffect(()=>{
        setRegion(locations)
      },[locations])
      

  return (
    <>
        <Box sx={{ display: "flex", gap: "15px"}}>
        <FormControl fullWidth>
        <Select
            displayEmpty
            value={wideloc}
            onChange={handleKeyChange}
            renderValue={(selected) => selected as string || "시/도"}
            input={<OutlinedInput notched={false} name="시/도"/>}
            MenuProps={menuProps}
            sx={sx}
            >
            {Object.keys(contents).map((region)=>(
                <MenuItem key={region} value={region}>
                    {region}
                </MenuItem>
            ))}
        </Select>
        </FormControl>
        <FormControl fullWidth >
        <Select
            value={cityloc}
            onChange={handleValueChange}
            renderValue={(selected) => selected || "시/군/구"}
            input={<OutlinedInput notched={false} name="시/군/구"/>}
            disabled={!wideloc}
            MenuProps={menuProps}
            displayEmpty
            sx={sx}>
            {(contents[wideloc] ?? []).map((district)=>(
                <MenuItem key={district} value={district}>
                    {district}
                </MenuItem>
            ))}
        </Select>
        </FormControl>
        </Box>
        <ManageRegionMyinfo user_area={locations} isModify={false}  setUser_area={setLocations}/>
    </>
  )
}

export default RegionSelectorMyInfo